import { Spacing } from '../../design-system/spacing';
import { styled } from '../../utils/styled';
import { Stack } from '../Stack';

export const StyledContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(Spacing.Medium),
  border: `1px solid ${theme.palette.neutral[200]}`,
  borderRadius: theme.borderRadii.outer,
  backgroundColor: theme.palette.paper[200],
  gap: theme.spacing(Spacing.Small),
}));

export const StyledTopStack = styled(Stack)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});

export const StyledTitleContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});
